import Axios from 'axios'

const baseURL = process.env.NEXT_PUBLIC_API_URL || ''

const axios = Axios.create({
  baseURL
})

axios.interceptors.request.use(
  (config) => {
    try {
      const user = JSON.parse(localStorage.getItem('@keycloak.user') ?? '{}')
      if (user) config.headers.Authorization = `Bearer ${user?.access_token}`
      return config
    } catch {
      return config
    }
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => {
    if (response.status != 200) {
      console.log('#STATUS', response.status)
    }

    return response
  },
  (error) => {
    if (error.response) {
      const status = error.response.status
      if (status === 401) {
        console.log('Unauthorized: Please log in again.')
      } else if (status === 403) {
        console.log(
          'Forbidden: You do not have permission to access this resource.'
        )
      }
    }

    return Promise.reject(error)
  }
)

export default axios
